export default function isDoubleNewLineInContents(contents) {
  return (
    contents &&
    contents.ops &&
    contents.ops[0] &&
    contents.ops[0].insert === "\n\n"
  );
}
